import { Link } from "react-router-dom";
import { Shield, Lock, ArrowRight, Layers, RefreshCw, Eye } from "lucide-react";

export default function Home() {
  const features = [
    { icon: Lock, title: "Token public en lecture seule", desc: "Le token identifie la configuration à afficher, jamais l'autorisation d'envoi." },
    { icon: Shield, title: "Relais serveur-à-serveur", desc: "Chaque soumission est relayée par le backend vers le SaaS, authentifiée par un secret partagé jamais exposé au navigateur." },
    { icon: RefreshCw, title: "File de retry courte", desc: "En cas d'indisponibilité, la demande est mise en file puis purgée après succès." },
    { icon: Eye, title: "Zéro rétention durable", desc: "Les données personnelles sont purgées immédiatement après transfert." },
  ];
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <header className="mx-auto flex max-w-6xl items-center justify-between px-6 py-6">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-400 text-slate-900">
            <Shield className="h-5 w-5" />
          </span>
          <span className="font-display text-lg font-bold">Passerelle RGPD</span>
        </div>
        <Link
          to="/admin/login"
          className="inline-flex items-center gap-2 rounded-md bg-white/10 px-4 py-2 text-sm font-semibold transition-colors hover:bg-white/20"
          data-testid="home-admin-link"
        >
          Console admin <ArrowRight className="h-4 w-4" />
        </Link>
      </header>

      <main className="mx-auto max-w-6xl px-6 pb-20 pt-12">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-medium text-sky-300">
            <Layers className="h-3.5 w-3.5" /> Front public + console de paramétrage + passerelle sécurisée
          </span>
          <h1 className="mt-6 font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
            Formulaires d'exercice des droits RGPD, isolés et sécurisés.
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
            Exposez des formulaires RGPD paramétrables par tenant — en page pleine, en iframe ou via script loader —
            et relayez chaque demande vers votre SaaS principal via une API signée, sans conservation durable des données.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/form/acme-demo-2026"
              className="inline-flex items-center gap-2 rounded-lg bg-sky-400 px-5 py-3 text-sm font-semibold text-slate-900 transition-colors hover:bg-sky-300"
              data-testid="home-demo-form"
            >
              Voir un formulaire de démo <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/admin/login"
              className="inline-flex items-center gap-2 rounded-lg border border-white/20 px-5 py-3 text-sm font-semibold transition-colors hover:bg-white/10"
            >
              Accéder au backoffice
            </Link>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f) => {
            const Icon = f.icon;
            return (
              <div key={f.title} className="rounded-xl border border-white/10 bg-white/5 p-5">
                <Icon className="h-6 w-6 text-sky-400" />
                <h3 className="mt-4 font-display text-base font-semibold">{f.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
